import React from 'react';
import RoleSymbol from "../../../../../../../../ui/RoleSymbol";

export default function NameCell(cellData) {
  let code = cellData.data.code;
  let commercial = cellData.data.commercial;

  return (
      <div>
        <div>{code}</div>
        {commercial && <div><br/>(Коммерческая)</div>}
      </div>
  );
}
